var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex flex-col min-h-screen"},[_c('cookie-consent',{staticClass:"top-16",attrs:{"cookies":[
      {
        displayName: 'Technical',
        cookieName: 'technical',
        description: 'We use technical cookies that ensure that the website can be used. Unfortunately, these cookies are absolutely necessary and cannot be disabled.',
        optional: false,
        initialStatus: true,
      },

      {
        displayName: 'Analytical',
        cookieName: 'analytical',
        description: 'We use Google Analytics to analyze the traffic of the website. You can find more information about this in our Privacy Policy statement.',
        optional: true,
        initialStatus: false,
      } ]}}),_vm._v(" "),_c('nav-bar'),_vm._v(" "),_c('main',{staticClass:"flex-grow mt-16"},[_vm._t("default")],2),_vm._v(" "),_c('new-app-footer',{attrs:{"margin-top":_vm.marginFooter}}),_vm._v(" "),_c('portal-target',{attrs:{"name":"modal","multiple":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }